function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#005A83",
  d: "M11.734375 2C11.636719 2 11.539063 2.011719 11.441406 2.03125L6.1875 3.15625C5.496094 3.304688 5 3.921875 5 4.625L5 10.28125C4.703125 10.109375 4.367188 10 4 10C2.902344 10 2 10.902344 2 12C2 13.097656 2.902344 14 4 14C5.097656 14 6 13.097656 6 12L6 6.40625L12 5.117188L12 9.28125C11.703125 9.109375 11.367188 9 11 9C9.902344 9 9 9.902344 9 11C9 12.097656 9.902344 13 11 13C12.097656 13 13 12.097656 13 11L13 3.292969C13 2.890625 12.828125 2.511719 12.535156 2.273438C12.3125 2.097656 12.03125 2 11.734375 2 Z M 11.808594 3.007813C11.851563 3.015625 11.878906 3.03125 11.90625 3.054688C11.957031 3.09375 12 3.160156 12 3.292969L12 4.09375L6 5.382813L6 4.625C6 4.386719 6.160156 4.1875 6.394531 4.136719L11.652344 3.007813C11.714844 2.996094 11.765625 2.996094 11.808594 3.007813 Z M 11 10C11.558594 10 12 10.441406 12 11C12 11.558594 11.558594 12 11 12C10.441406 12 10 11.558594 10 11C10 10.441406 10.441406 10 11 10 Z M 4 11C4.558594 11 5 11.441406 5 12C5 12.558594 4.558594 13 4 13C3.441406 13 3 12.558594 3 12C3 11.441406 3.441406 11 4 11Z",
  vectorEffect: "non-scaling-stroke"
}));

var SvgIcons8Music = function SvgIcons8Music(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8Music, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8_music.da59afdd.svg";
export { ForwardRef as ReactComponent };